<div class="container">

   <app-page-title title="App Links"
                   icon="fa-mobile-screen-button"
                   eyebrow="Apps"
                   subtitle="Download the Southwestern apps for your phone or tablet" />

   <p class="platform-note">
      <i class="fa-brands {{ platformIsAndroid() ? 'fa-android' : 'fa-apple' }}" aria-hidden="true"></i>
      Store links are for {{ platformIsAndroid() ? 'Android' : 'iPhone and iPad' }}, based on this device.
   </p>

   <div class="link-groups">
      @for (group of linkGroups(); track group.title) {
         <section class="link-group">
            <h2 class="group-title">{{ group.title }}</h2>
            <div class="tiles">
               @for (link of group.links; track link.title) {
                  @if (link.routerLink) {
                     <a class="tile" [routerLink]="link.routerLink">
                        <span class="icon"><i class="fa-solid {{ link.icon }}" aria-hidden="true"></i></span>
                        <span class="text">
                           <span class="title">{{ link.title }}</span>
                           <span class="description">{{ link.description }}</span>
                        </span>
                        <span class="badge-pill">
                           <i class="{{ badges[link.kind].icon }}" aria-hidden="true"></i>{{ badges[link.kind].label }}
                        </span>
                     </a>
                  } @else {
                     <a class="tile" role="button" tabindex="0"
                        (click)="goToExternal(link.externalUri)"
                        (keydown.enter)="goToExternal(link.externalUri)">
                        <span class="icon"><i class="fa-solid {{ link.icon }}" aria-hidden="true"></i></span>
                        <span class="text">
                           <span class="title">{{ link.title }}</span>
                           <span class="description">{{ link.description }}</span>
                        </span>
                        <span class="badge-pill">
                           <i class="{{ badges[link.kind].icon }}" aria-hidden="true"></i>{{ badges[link.kind].label }}
                        </span>
                     </a>
                  }
               }
            </div>
         </section>
      }
   </div>

</div>
